import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=21b45027&scoped=true"
import script from "./caseDetail.vue?vue&type=script&lang=js"
export * from "./caseDetail.vue?vue&type=script&lang=js"
import style0 from "./caseDetail.vue?vue&type=style&index=0&id=21b45027&prod&lang=css"
import style1 from "./caseDetail.vue?vue&type=style&index=1&id=21b45027&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b45027",
  null
  
)

export default component.exports